// The ORIGINAL backend translation service translates nested `text` fields,
// but not Math Rods' plain string `choices` array. Keep a per-choice text mirror
// within this template's own document, so the shared translator stays untouched.
const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);

export function mirrorChoiceTexts(segment) {
  if (!isObject(segment) || segment.type !== 'choice' || !Array.isArray(segment.choices)) return segment;
  const details = Array.isArray(segment.choiceDetails) ? segment.choiceDetails : [];
  return {
    ...segment,
    choiceDetails: segment.choices.map((value, index) => ({
      ...(isObject(details[index]) ? details[index] : {}),
      text: typeof value === 'string' ? value : '',
    })),
  };
}

// On immersion data, the existing translator updates choiceDetails[].text.
// The old `choices[]` remains as source metadata. Only the Math Rods reader
// substitutes translated choices for the displayed/edited version.
export function readTranslatedChoices(segment) {
  if (!isObject(segment) || segment.type !== 'choice' || !Array.isArray(segment.choices)) return segment;
  return {
    ...segment,
    choices: segment.choices.map((value, index) => {
      const text = segment.choiceDetails?.[index]?.text;
      return typeof text === 'string' ? text : value;
    }),
  };
}

export const mirrorMathRodsDocument = content => isObject(content) ? {
  ...content,
  problems: Array.isArray(content.problems) ? content.problems.map(mirrorChoiceTexts) : content.problems,
} : content;

export const readMathRodsDocument = content => isObject(content) ? {
  ...content,
  problems: Array.isArray(content.problems) ? content.problems.map(readTranslatedChoices) : content.problems,
} : content;
